import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { publicHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { profileApiPath } from './apiPath';

/**
 * SNS 링크 정보 스키마
 */
export const SnsLinkSchema = z.object({
  platform: z
    .union([
      z.literal('INSTAGRAM'),
      z.literal('YOUTUBE'),
      z.literal('TWITTER'),
      z.literal('TIKTOK'),
      z.literal('ETC'),
    ])
    .describe('SNS 플랫폼 타입'),
  url: z.string().describe('SNS 링크 URL'),
});

export type SnsLinkType = z.infer<typeof SnsLinkSchema>;

/**
 * 큐레이터 본인 프로필 조회 응답 스키마
 */
export const ProfileSchema = z.object({
  nickname: z.string().describe('닉네임'),
  profileImage: z.string().nullable().describe('프로필 이미지 URL, MUSINSA의 경우 null 가능'),
  shopDescription: z.string().nullable().describe('큐레이션 샵 소개글'),
  shopLink: z.string().nullable().describe('큐레이터샵 단축 링크 (본인 샵일 때만 값 존재 가능)'),
  snsLinks: z.array(SnsLinkSchema).describe('SNS 링크 목록'),
  isMyShop: z.boolean().describe('조회 주체가 해당 샵의 소유자 여부'),
});

export type ProfileType = z.infer<typeof ProfileSchema>;

const GetCuratorProfileResponseSchema = createApiResponseSchema(ProfileSchema);
export type GetCuratorProfileResponseType = z.infer<typeof GetCuratorProfileResponseSchema>;

const GetCuratorProfileRequestSchema = z.object({
  snsTitle: z.string().describe('큐레이션 샵 SNS 타이틀'),
});
export type GetCuratorProfileRequestParams = z.infer<typeof GetCuratorProfileRequestSchema>;

// 5. API 함수 구현 (함수형 파이프라인 패턴)
export const getCuratorProfileBySnsTitle = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetCuratorProfileRequestSchema),
    (params: GetCuratorProfileRequestParams) =>
      executeStandardRequest(async () =>
        publicHttpClient.get<GetCuratorProfileResponseType>(
          profileApiPath.getCuratorProfileBySnsTitle(params.snsTitle),
        ),
      ),
    validateApiResponse(GetCuratorProfileResponseSchema),
  ),
);
